/**
 * How many of a list's items fit, whole, in its container. The screen's stage
 * grows with the screen's shape, so lists measure rather than guess: render up
 * to `max`, then hide whatever would be cut off at the bottom.
 */
export const useFitCount = (containerRef, itemSelector, max) => {
    const count = ref(max);
    let observer = null;

    const measure = () => {
        const box = containerRef.value;
        if (!box) return;
        const items = [...box.querySelectorAll(itemSelector)];
        const limit = box.getBoundingClientRect().bottom;
        let fits = 0;
        for (const item of items) {
            if (item.getBoundingClientRect().bottom <= limit + 1) fits++;
            else break;
        }
        count.value = Math.max(1, fits);
    };

    // Show everything, let it lay out, then trim
    const remeasure = async () => {
        count.value = max;
        await nextTick();
        measure();
    };

    onMounted(() => {
        remeasure();
        observer = new ResizeObserver(() => remeasure());
        if (containerRef.value) observer.observe(containerRef.value);
    });
    onUnmounted(() => observer?.disconnect());

    return {count, remeasure};
};
